export default {
  modelVersion: '1.2.0',
  annualGrowthRate: 8, // Default annual growth rate percentage
  
  // Impact scores by factor and industry/tier combination
  matrixScores: {
    designReuse: {
      'automotive:OEM': 75,
      'automotive:T1': 65,
      'aerospace:OEM': 80,
      'electronics:OEM': 70
    },
    changeManagement: {
      'automotive:OEM': 60,
      'automotive:T1': 55,
      'aerospace:OEM': 70,
      'electronics:OEM': 65
    },
    // Add all other factors...
  },
  
  // Maximum impact percentages by factor
  maxImpactPercents: {
    designReuse: 2.5, // Max 2.5% of revenue impact
    changeManagement: 1.8,
    // Add all other factors...
  }
};